import type { ProductSeoPayload } from '@iheartjane/data-access';
import { memo } from 'react';
import { Helmet } from 'react-helmet-async';
import { helmetJsonLdProp } from 'react-schemaorg';

interface Props {
  payload: ProductSeoPayload;
}

export const ProductSeoHead = memo(function ProductSeoHead({ payload }: Props) {
  const { canonical_url, description, image_url, og, title } = payload;

  return (
    <Helmet script={[helmetJsonLdProp(payload.structured_data)]}>
      <html
        lang="en"
        // eslint-disable-next-line react/no-unknown-property
        prefix="og: http://ogp.me/ns# fb: http://ogp.me/ns/fb# product: http://ogp.me/ns/product#"
      />

      {!!title && <title>{title}</title>}
      {!!description && <meta name="description" content={description} />}
      {!!canonical_url && <link rel="canonical" href={canonical_url} />}

      {!!title && <meta property="og:title" content={title} />}
      {!!description && (
        <meta property="og:description" content={description} />
      )}
      {!!og.url && <meta property="og:url" content={og.url} />}
      {!!image_url && <meta property="og:image" content={image_url} />}
      {!!image_url && <meta name="twitter:image" content={image_url} />}
      {!!og.site_name && (
        <meta property="og:site_name" content={og.site_name} />
      )}
      {!!og.fb_app_id && <meta property="fb:app_id" content={og.fb_app_id} />}
      {!!og.twitter_handle && (
        <meta name="twitter:creator" content={og.twitter_handle} />
      )}
      {!!og.twitter_handle && (
        <meta name="twitter:site" content={og.twitter_handle} />
      )}
      {!!title && <meta name="twitter:title" content={title} />}
      {!!description && (
        <meta name="twitter:description" content={description} />
      )}
      {!!og.type && <meta property="og:type" content={og.type} />}
      {!!og.locale && <meta property="og:locale" content={og.locale} />}
      {!!og.twitter_card && (
        <meta name="twitter:card" content={og.twitter_card} />
      )}
    </Helmet>
  );
});
